module.exports = function (app) {
    "use strict";

    app.directive('btsFormMessagesGenerator', function ($compile, $timeout, $parse) {

        /*
         * @ngDoc directive
         * @name btsFormMessagesGenerator
         * @description This generates a series of ng-messages attached to inputs/fieldsets based on the form controller from Angular and on the list of registered validators on those inputs/fields.
         *
         * Make sure to name your inputs/selects/textareas if you want this form to create ng-message validation feedback for you. Unnamed fields don't appear in the form controllers list. Workaround hasn't been discovered yet.
         * i.e. name="insuranceCarrier_{{$index}}"
         *
         *
         * Custom NG-Messages can be added by simply adding them after the input on the html. Add them after the input enclosed in a <label>, or as the last child of a fieldset. The directive will skip adding its own ng-messages in that case so that you don't end up with duplicate validation errors. TODO: Might be a possibility of adding a configurable attribute object to pass in to add to the list of default messages generated.
         *
         * @status Review
         * @params n/a
         * @scope Parent
         * @template n/a
         */

        return {
            priority: 50,
            restricted: "A",
            replace: false,
            require: "form",
            compile: function (tElement) {

                tElement.attr('novalidate', true);
                return {
                    post: function postLink(scope, element, attribute, ctrl) {

                        var form = ctrl;
                        /*
                         * @ngDoc Method
                         * @name btsFormMessagesGenerator#ngMessageBuilder
                         * Passes an HTML template back to the $compile based on the validators found on the form input, or based on type of inputs due to some validations not being registered as expected. Affects UI-Mask and Date-Input.
                         *
                         */
                        var ngMessageBuilder = function (validators, inputEl) {
                            var defaultMessages = {
                                required: '<span data-ng-message="required">This field is required</span>',
                                minlength: '<span data-ng-message="minlength">Too Short. ' + ( inputEl.attributes.minlength && inputEl.attributes.minlength.value || '') + ' Character minimum.</span>',
                                maxlength: '<span data-ng-message="maxlength">Too Long. ' + ( inputEl.attributes.maxlength && inputEl.attributes.maxlength.value || '') + '  Character maximum exceeded</span>',
                                email: '<span data-ng-message="email">A valid email address is required. Ensure common email formats are followed, such as an @ symbol </span>',
                                date: '<span data-ng-message="date">This is not a valid date</span>',
                                min: '<span data-ng-message="min">This date comes before allowed date range</span>',
                                max: '<span data-ng-message="max">This date comes after allowed date range</span>',
                                mask: '<span data-ng-message="mask">Please complete field correctly.</span>',
                                coverage: '<span data-ng-message="coverage">Subscriber must be selected for plan if dependent is selected.</span>',
                                pattern: '<span data-ng-message="pattern">The value entered is not valid.</span>',
                                passwordRules: '<span data-ng-message="passwordRules">Your password does not meet the rules. Please check & try again.</span>'
                            };

                            var customConfig = inputEl.attributes['data-custom-errors'] || inputEl.attributes['custom-errors'];
                            var parsedValue, customValue;
                            if (customConfig) {
                                customValue = customConfig.value;
                            }

                            try {
                                parsedValue = $parse(customValue)(scope);
                            } catch (e) {
                                parsedValue = null;
                            }

                            var forcedMessages = inputEl.attributes['data-include-errors'] || inputEl.attributes['include-errors'];
                            if (forcedMessages && forcedMessages.value) {
                                angular.forEach(forcedMessages.value.split(','), function (validator) {
                                    validator = validator.replace(/[^a-zA-Z]/g, '');
                                    if (validators.indexOf(validator) === -1) {
                                        validators.push(validator);
                                    }
                                });
                            }

                            var customMessages = {};
                            if (customConfig) {
                                angular.forEach(parsedValue, function (message, validator) {
                                    customMessages[validator] = '<span data-ng-message="' + validator + '">' + message + '</span>';
                                });
                            }

                            var messages = [];
                            for (var i = 0; i < validators.length; i++) {
                                if (customMessages[validators[i]]) {
                                    messages.push(customMessages[validators[i]]);
                                } else if (defaultMessages[validators[i]]) {
                                    messages.push(defaultMessages[validators[i]]);
                                }
                            }
                            if (inputEl.type === 'date') {
                                messages.push(defaultMessages.date);
                            }
                            if (inputEl.attributes['data-ui-mask']) {
                                messages.push(defaultMessages.mask);
                            }
                            return messages.join('');
                        };
                        /*
                         * @ngDoc Method
                         * @name btsFormMessagesGenerator#findInputsThenBuildMessages
                         * Passes an HTML template back to the $compile based on the validators found on the form input, or based on type of inputs due to some validations not being registered as expected. Affects UI-Mask and Date-Input.
                         *
                         * */
                        var findInputsThenBuildMessages = function (nestedForm) {

                            var iterateForm = nestedForm || form;
                            //Timeout makes sure all other directives have loaded before running these inserts.
                            $timeout(function () {

                                angular.forEach(form, function (input) {

                                    if (input && input.$name && !input.$$parentForm) {
                                        //if (input && input.$name) {
                                        var inputName = input.$name;
                                        var targetEl = {};
                                        var inputEl = angular.element('[name=' + inputName + ']');
                                        var inputLabel = inputEl.parent('label');
                                        //If input has a label, and not a radio button.
                                        if (inputLabel[0] && inputEl[0] && inputEl[0].type !== 'radio' && inputEl[0].type !== 'checkbox') {
                                            if (!inputLabel.next('.validationErrorContainer')[0]) {
                                                targetEl = inputLabel.children('').last().not('.validationErrorContainer');
                                            }
                                        } else
                                        //If Radio or checkbox, then get the closest fieldset to place the validation after.
                                        if (inputEl[0] && inputEl[0].type && (inputEl[0].type === 'radio' || inputEl[0].type === 'checkbox')) {
                                            //    find FieldSet, apply to that last child of the fieldset, make sure a .validationErrorContainer doesn't already exist.
                                            targetEl = inputEl.closest('fieldset').children().last().not('.validationErrorContainer');

                                        } else
                                        //if you can't find any of these other options, then just place immediately after input.
                                        if (!inputEl.next('.validationErrorContainer')[0]) {
                                            targetEl = inputEl;
                                        }
                                        if (targetEl[0] && inputName && iterateForm[inputName] && Object.keys(iterateForm[inputName].$validators).length > 0) {
                                            var validators = Object.keys(iterateForm[inputName].$validators);
                                            var template = angular.element('<div data-form="' + iterateForm.$name + '"data-validation="' + iterateForm.$name + '.' + inputName + '">' + ngMessageBuilder(validators, inputEl[0]) + '</div>');
                                            $compile(template)(scope, function (clonedElement) {
                                                clonedElement.insertAfter(targetEl);
                                            });
                                        }
                                    }
                                });
                            }, 0);
                        };
                        // Initialize and Watch
                        findInputsThenBuildMessages();
                        scope.$watchCollection(function () {
                            return form;
                        }, function (newData, oldData) {
                            if (newData !== oldData) {
                                findInputsThenBuildMessages();
                            }
                        });
                    }
                };
            }
        };
    });
};